export var StripeAccountType;
(function (StripeAccountType) {
    StripeAccountType["express"] = "express";
    StripeAccountType["standard"] = "standard";
})(StripeAccountType || (StripeAccountType = {}));
export class StripeAccount {
    id = null;
    accountId = null;
    type = StripeAccountType.standard;
    payoutsEnabled = false;
    chargesEnabled = false;
    email = null;
    constructor(id, data) {
        this.id = id || null;
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
